import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { Observable, of, tap } from 'rxjs';
import { inject } from '@angular/core';
import { FormBuilderStore } from '../store/form-builder.store';

export const formBuilderResolver: ResolveFn<Observable<boolean>> = (
  route: ActivatedRouteSnapshot,
): Observable<boolean> => {
  const store = inject(FormBuilderStore);
  const templateId = route.paramMap.get('templateId')!;

  return of(true).pipe(
    tap(() => {
      store.getFormTemplateById(templateId);
    }),
  );
};
